import cookie from 'js-cookie';

export const setCookie = (key, value) => {
  if (process.browser) {
    cookie.set(key, btoa(JSON.stringify(value)), {
      expires: 1,
      path: '/'
    });
  }
};

export const removeCookie = key => {
  if (process.browser) {
    cookie.remove(key, {
      expires: 1
    });
  }
};

export const getCookie = key => {
  const cookieValue = cookie.get(key);
  console.log("Cookie value", cookieValue);
  let value = '';

  if (cookieValue) {
    value = JSON.parse(atob(cookieValue));
  }

  return value;
}



// WEBPACK FOOTER //
// ./src/utils/session.js